import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axiosApi from "./api/axios.js";
import Element from 'element-ui'
import VueParticles from 'vue-particles'
import config from './api/config.js'
import './element-variables.scss'

Vue.config.productionTip = false;
Vue.prototype.$baseUrl = config.BASE_URL;

Vue.use(Element)
Vue.use(axiosApi)
Vue.use(VueParticles)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
